import { useEffect, useRef, useState } from 'react';

export const useDebounce = (value: any, delay = 200) => {
  const [debouncedValue, setDebouncedValue] = useState<any>(value);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    timerRef.current = setTimeout(() => setDebouncedValue(value), delay);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [value, delay]);

  return debouncedValue;
};
